import React from "react";
import { ShieldAlert } from "lucide-react";

export function ComplianceBar() {
  return (
    <div className="w-full bg-white border-b border-slate-200 text-slate-400 text-[10.5px]" data-testid="compliance-banner">
      <div className="max-w-[1600px] mx-auto px-4 py-1.5 flex items-center gap-2 justify-center text-center">
        <ShieldAlert className="h-3.5 w-3.5 shrink-0" />
        <span className="font-mono tracking-wide">
          ANALYTICS &amp; RESEARCH TOOL ONLY · NOT SEBI-REGISTERED INVESTMENT ADVICE OR TIPS · F&amp;O TRADING CARRIES HIGH RISK OF LOSS
        </span>
      </div>
    </div>
  );
}

export function ComplianceFooter() {
  return (
    <footer className="border-t border-slate-200 mt-10 py-6 px-4 text-center text-xs text-slate-500 font-mono">
      <p className="max-w-3xl mx-auto leading-relaxed">
        Trading Flow Review is an analytics and research platform. All TFR observations are quantitative,
        not buy/sell recommendations or tips. We are not SEBI-registered investment advisers. Derivatives trading involves
        substantial risk. Market data: DhanHQ live feed and official NSE end-of-day files.
      </p>
    </footer>
  );
}
